

const FieldError = ({ message }) => {

    let content = null;
    if (message) {
        content = (
            <div className="invalid-feedback d-block" >{message}</div>
        );
    }
    return content;
}

export default FieldError;

